import BaseApi from "../base";

export default class Customer extends BaseApi {

}

